import { LeftChevron } from 'assets/Icons'
import { Modal } from 'components/Overlay'
import Spinner from 'components/Spinner'
import notification from 'helpers/notification'
import React, { Fragment, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import services from 'services/index'

const Header = ({ role }) => {
	const navigate = useNavigate()
	const params = useParams()
	const { id } = params
	const [visibleDelete, setVisibleDelete] = useState(false)
	const [loading, setLoading] = useState(false)
	const deleteGroup = id => {
		const options = {
			id,
			onEnd: () => setLoading(false),
			onStart: () => setLoading(true),
			onError: () => notification('Error', { type: 'error' }),
			onSuccess: () => {
				navigate('/account/groups')
				notification("Guruh o'chirildi", { type: 'success' })
				setVisibleDelete(false)
			},
		}
		services.groups.deleteGroups(options)
	}
	return (
		<Fragment>
			<div className='flex items-center justify-between mb-4'>
				<div className='flex items-center justify-start gap-1 sm:gap-2'>
					<span
						className='p-1 rounded-[10px] text-[#292A32] dark:text-[#ffffff] hover:text-[#018ECC] dark:hover:text-[#018ECC] hover:cursor-pointer hover:bg-[#e8e8e8] dark:hover:bg-[#414141]'
						onClick={() => navigate('/account/groups')}
					>
						<LeftChevron />
					</span>
					<h1 className='text-[18px] lg:text-[24px] text-[#292A32] dark:text-[#ffffff] font-semibold'>
						Guruh № {id}
					</h1>
				</div>
				{role === 'admin' && (
					<div className='flex items-center gap-3'>
						<button
							className='danger-btn'
							onClick={() => setVisibleDelete(true)}
						>
							O'chirish
						</button>
						<button
							className='success-btn'
							onClick={() => navigate(`/account/groups/update/${id}`)}
						>
							Tahrirlash
						</button>
					</div>
				)}
			</div>
			<Modal
				onClose={() => setVisibleDelete(false)}
				onOpen={() => setVisibleDelete(true)}
				open={visibleDelete}
			>
				{loading ? (
					<div className='w-[450px] h-[227px] flex items-center justify-center'>
						<Spinner />
					</div>
				) : (
					<div className='py-[32px] px-[24px]'>
						<h4 className='text-[#292B32] dark:text-[#f2f2f2] text-[24px] font-bold m-0 text-center'>
							Guruhni o‘chirish
						</h4>
						<p className='text-[#292B32] dark:text-[#f2f2f2] text-lg font-medium mx-0 mt-[16px] mb-[0] text-center'>
							Haqiqatan ham ushbu guruhni o‘chirmoqchimisiz?
						</p>
						<div className='flex justify-center items-center mt-[24px]'>
							<button
								className='mute-btn mr-5 min-w-[150px]'
								onClick={() => setVisibleDelete(false)}
							>
								Bekor qilish
							</button>
							<button
								className='danger-btn min-w-[150px]'
								onClick={() => deleteGroup(id)}
							>
								Ha
							</button>
						</div>
					</div>
				)}
			</Modal>
		</Fragment>
	)
}

export default Header
